import React from 'react';

/**
 * Pantalla para los modulos del panel que todavia no estan construidos.
 * Se prefiere esto antes que un enlace roto o una pantalla con datos falsos:
 * el menu queda completo y cada modulo explica que hara y que necesita.
 */
export default function ModuloPendiente({ titulo, icono, descripcion, incluye = [], requiere = [] }) {
  return (
    <div className="page-content">
      <div className="page-header">
        <div className="page-header-text">
          <h2>{icono} {titulo}</h2>
          <p>{descripcion}</p>
        </div>
        <span className="badge badge-warning">En construcción</span>
      </div>

      <div className="card" style={{ padding: '1.5rem', maxWidth: 780 }}>
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18 }}>
          <div style={{ fontSize: '1.8rem', lineHeight: 1 }}>🚧</div>
          <div>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>Este módulo aún no está disponible</div>
            <div style={{ fontSize: '0.88rem', color: 'var(--color-text-muted)', lineHeight: 1.55 }}>
              Forma parte del panel de administración y se entregará en una etapa posterior.
              Se muestra en el menú para que la navegación quede completa.
            </div>
          </div>
        </div>

        {incluye.length > 0 && (
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontWeight: 600, fontSize: '0.85rem', marginBottom: 8 }}>Qué incluirá</div>
            <ul style={{ margin: 0, paddingLeft: 20, fontSize: '0.87rem', lineHeight: 1.8, color: 'var(--color-text-muted)' }}>
              {incluye.map((i, k) => <li key={k}>{i}</li>)}
            </ul>
          </div>
        )}

        {requiere.length > 0 && (
          <div style={{
            padding: '12px 14px', borderRadius: 10,
            background: 'var(--color-surface)', borderLeft: '3px solid var(--color-gold)',
          }}>
            <div style={{ fontWeight: 600, fontSize: '0.84rem', marginBottom: 6 }}>Qué hace falta para construirlo</div>
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: '0.84rem', lineHeight: 1.7, color: 'var(--color-text-muted)' }}>
              {requiere.map((r, k) => <li key={k}>{r}</li>)}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
